var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLink',{class:[
        _vm.secondary ? _vm.$style.secondary : _vm.$style.primary,
        _vm.active && _vm.secondary ? _vm.$style.activeSecondary : _vm.active ? _vm.$style.activePrimary : '' ],attrs:{"tag":"div","to":_vm.href ? null : { name: _vm.to },"href":_vm.href ? _vm.href : null},on:{"click":function($event){return _vm.$emit('cliked')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }